
import { Injectable } from '@angular/core';
import { Platform } from 'ionic-angular';
import { LoginPage } from '../../pages/login/login';

/*
  Generated class for the SplitPaneProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class SplitPaneProvider { 

  
  splitPaneState: boolean;

  constructor(public platform: Platform) {
      this.splitPaneState = false;
  }

  setSplitPane(state: boolean) {
      if (this.platform.width() > 768) {
          this.splitPaneState = state;
      } else {
          this.splitPaneState = false;
      }
  }

  getSplitPane() {
      return this.splitPaneState;
  }
}



// WEBPACK FOOTER //
// ./src/providers/split-pane/split-pane.ts